// components/FilterContainer.jsx
import React from 'react';
import BidPriceFilter from './filters/BidPriceFilter';
import Skills from './Skills';
import AutoBidSettingsFilter from './filters/AutoBidSettingsFilter';

const FilterContainer = ({ activeTab = "bid-price", filters = {} }) => {
  const renderFilter = () => {
    if (activeTab === 'skills') {
    return <Skills />;
  }
    switch (activeTab) {
      
      case 'bid-price':
        return (
          <BidPriceFilter 
            maxBidsPerDay={filters.maxBidsPerDay || ''}
            setMaxBidsPerDay={filters.setMaxBidsPerDay || (() => {})}
          />
        );

        case 'auto_bid':
        return (
          <AutoBidSettingsFilter
          />
        );

        

      default:
        return <div className="text-gray-500">Select a valid filter.</div>;
    }
  };

  return <div>{renderFilter()}</div>;
};

export default FilterContainer;
  